import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
import { Router, RouterLink } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs';

import { ComponentBase } from 'app/shared/component.base';
import { NavigationHeaderItem, NavigationItem } from 'app/shared/models/common.models';
import { CategoriesService } from 'app/shared/services/categories.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [RouterLink, MatButtonModule, MatIconModule, MatExpansionModule]
})
export class NavigationComponent extends ComponentBase implements OnInit {
	@Input() drawer: MatDrawer;
	navItems: NavigationHeaderItem[];
	expandedCategoryIndex: number | null = null;
	panelOpenState: boolean = false;

	constructor(
		private categoriesService: CategoriesService,
		private toastr: ToastrService,
		private router: Router,
	) {
		super();

		this.navItems = [
			{
				name: 'Shop wine',
				showHoverable: false,
				linkPrefix: 'category/',
				links: [
					{
						id: 0,
						urlSlug: 'listings',
						name: 'All listings',
					},
				],
			},
			{
				name: 'Shop accessories',
				showHoverable: false,
				linkPrefix: '',
				links: [
					{
						id: 0,
						name: 'All accessories',
						urlSlug: 'accessories',
					},
				],
			},
			{
				name: 'Resources',
				showHoverable: false,
				linkPrefix: 'resources/',
				links: [
					{
						name: 'Education',
						urlSlug: 'education',
					},
					{
						name: 'Most Collected Wines of 2023',
						urlSlug: 'most-collected-wines-of-2023',
					},
					{
						name: 'Glossary',
						urlSlug: 'glossary',
					},
					{
						name: 'Provenance Program',
						urlSlug: 'provenance-program',
					},
					{
						name: 'FAQ',
						urlSlug: 'faq',
					},
				],
			},
			{
				name: 'About',
				showHoverable: false,
				linkPrefix: 'about/',
				links: [
					{
						name: 'About Wine Ark',
						urlSlug: '',
					},
					{
						name: 'Manage Cellarage Offering',
						urlSlug: 'manage-cellarage-offering',
					},
					{
						name: 'Terms & Conditions',
						urlSlug: 'terms-and-conditions',
					},
					{
						name: 'Why Wine Ark?',
						urlSlug: 'why-wine-ark',
					},
					{
						name: 'Testimonials',
						urlSlug: 'testimonials',
					},
					{
						name: 'Cellar Locations',
						urlSlug: 'cellar-locations',
					},
				],
			},
			{
				name: 'Contact',
				showHoverable: false,
				url: 'contact',
				links: [],
			},
		];
	}

	ngOnInit(): void {
		this.categoriesService
			.getNavigationItemsV1()
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe({
				next: (results) => {
					this.navItems[0].links = this.navItems[0].links.concat(results as NavigationItem[]);
				},
				error: () => {
					this.toastr.error(
						'An error has occurred, please try again. If the issue persists, please contact Wine Ark.',
						'Error occurred',
					);
				},
			});
	}

	openDrawer(): void {
		this.panelOpenState = true;
		this.drawer.open();
	}

	closeDrawer(): void {
		this.panelOpenState = false;
		document.body.style.overflow = '';
		this.drawer.close();
	}

	handlePanelOpen(index: number) {
		if (this.expandedCategoryIndex !== index) {
			this.expandedCategoryIndex = index;
		} else {
			// Only set to null if the same panel is closing
			this.expandedCategoryIndex = null;
		}
	}

	handlePanelClose(index: number) {
		// Only reset `expandedCategoryIndex` if the panel being closed is the currently expanded one
		if (this.expandedCategoryIndex === index) {
			this.expandedCategoryIndex = null;
		}
	}

	navigateToPage(link: string) {
		this.router.navigate([link]);
		this.closeDrawer();
	}
}
